module.exports = __webpack_public_path__ + "images/index/art.fcc72fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/connect/art.jpg
// module id = 1+KD
// module chunks = 21